// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"ceee8638","30":"1bee7ec3","226":"40b472a7","453":"68693753","458":"5966e331","954":"9a4244c7"}[chunkId] + ".chunk.js";
};